<template>
    <div class="d-flex justify-center align-center">
      <v-card min-width="400">
        <v-container fluid>
          <v-row>
            <v-col v-if="settings && logoLoaded" class="col-12 col-sm-6">
              <v-img height="100%" contain src="" alt="Napco Truck Tracking" class="logo" />
            </v-col>
            <v-col class="left-border col-12" :class="logoLoaded ? 'col-sm-6' : ''">
            <img src="../assets/napco-logo.png" style="width: 142px;
      margin-left: 30%;"/>
              <v-card-title>Napco Truck Tracking</v-card-title>
              <v-card-subtitle>Please enter the OTP sent to your email to access the CMS</v-card-subtitle>
              <v-container>
                <v-row>
                  <v-col cols="12" align="center">
                    <v-form ref="loginForm">
                      <v-alert color="primary lighten-1" type="error" v-if="message != ''" dense>{{message}}</v-alert>
                      <!-- <v-text-field
                        color="green"
                        outlined
                        dense
                        label="OTP Code"
                        v-model="userOtp.otp"
                        :disabled="loading || loadingResend"
                      ></v-text-field> -->
                      <div style="max-width:300px">
                      <v-otp-input
                      v-model="userOtp.otp"
                      :length="6"
                      :disabled="loading || loadingResend"
                      ></v-otp-input>
                    </div>
                      
                      <v-btn color="primary mr-2" @click="submit" :loading="loading" :disabled="userOtp.otp == '' || userOtp.otp.length < 6">
                        <v-icon left dark>mdi-login</v-icon>Verify
                      </v-btn>
                      <v-btn color="primary mr-2" @click="resend" :loading="loadingResend" >
                        <v-icon left dark>mdi-login</v-icon>Resend
                      </v-btn>
                    </v-form>
                    <v-btn color="primary mt-4" @click="logout" >
                        <v-icon class="mr-2">logout</v-icon>Logout
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  
  export default {
    data() {
      return {
        message: "",
        loading: false,
        loadingResend: false,
        userOtp: {
        userLoggedIn: "",
        otp: ""
      }
      };
    },
    computed: {
    ...mapState('users',['user']),
    ...mapState({
        settings: state => state.settings.settings
      }),
      logoLoaded() {
        console.log(this.settings)
        if(this.settings !== undefined)
          return ""
        return false
      }
    },
    created() {
          this.userOtp.userLoggedIn = this.user.id;
    },
    methods: {
      ...mapActions('users',['authenticate','logout', 'verifyOtp', 'resendOtp']),
      submit() {
        this.message = "";
        this.loading = true;
        if (this.$refs.loginForm.validate()) {
          this.verifyOtp(this.userOtp)
            .then(message => { 
                // this.$router.push('home') 
            })
            .catch(message => {
              this.message = message; 
            })
            .finally(_ => {
              this.loading = false;
            });
        }
      },
      resend() {
        this.loadingResend = true;
          this.resendOtp(this.userOtp)
            .then(message => { 
                // this.$router.push('home') 
              this.message = "OTP resent"; 
            })
            .catch(message => {
              this.message = message; 
            })
            .finally(_ => {
              this.loadingResend = false;
            });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .logo {
    width: 100%;
    max-width: 400px;
  }
  
  .left-border {
    border-left: 1px solid rgba(black,0.1);
  }
  </style>